export default function identity() {
  return true
}
